import localize from "./localize"

const en = {
  // **** Navigation ****
  navLink1: "Home",
  navLink2: "Our Story",
  navLink3: "Bread",
  navLink4: "Pastries",
  navLink5: "Shop",
  navLink6: "Contact",

  // **** Landing page ****
  welcomeSubheader: "Welcome to",
  bakeryHeader: "We are more than a bakery",
  bakeryGridBreadContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  bakeryGridPastriesContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  bakeryGridShopContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  bakeryGridOurStoryContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  bakeryGridContactContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  // **** our Story page ****

  // **** our Breads page ****
  breadHeader: "our Bread",
  breadDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 1
  ourBreadHeader1: "Whole grain bred",
  ourBreadDesc1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 2
  ourBreadHeader2: "Sourdough bred",
  ourBreadDesc2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 3
  ourBreadHeader3: "Multi grain bread",
  ourBreadDesc3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 4
  ourBreadHeader4: "Wholerye bred",
  ourBreadDesc4: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 5
  ourBreadHeader5: "Island bred",
  ourBreadDesc5: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 6
  ourBreadHeader6: "Cerial bred",
  ourBreadDesc6: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 7
  ourBreadHeader7: "Spelt bred",
  ourBreadDesc7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 8
  ourBreadHeader8: "Bulgur bred",
  ourBreadDesc8: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 9
  ourBreadHeader9: "Extra dark bred",
  ourBreadDesc9: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",

  // **** our Pastries page ****
  pastriesHeader: "our Pastries",
  pastriesDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 1
  ourPastriesHeader1: "Oat deligh",
  ourPastriesDesc1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 2
  ourPastriesHeader2: "Cleinia",
  ourPastriesDesc2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 3
  ourPastriesHeader3: "Bluberry cookie",
  ourPastriesDesc3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 4
  ourPastriesHeader4: "Artic dream",
  ourPastriesDesc4: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 5
  ourPastriesHeader5: "Island muffin",
  ourPastriesDesc5: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 6
  ourPastriesHeader6: "Ice cubes",
  ourPastriesDesc6: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 7
  ourPastriesHeader7: "Kettleballs",
  ourPastriesDesc7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 8
  ourPastriesHeader8: "Grandma's secret",
  ourPastriesDesc8: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 9
  ourPastriesHeader9: "Oat respberry cookie",
  ourPastriesDesc9: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",

  // **** Contact page ****
  contactHeader: "contact Us",
  contactDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  openingHoursHeader: "Opening hours",
  openingHoursWeekdays: "Monday - Friday",
  openingHoursWeekends: "Saturday and Sunday",
  getInTouchHeader: "Get in touch",
  getInTouchAddress: "Újezd 11, 150 00 Prague, Czech Republic",
  // Contact form
  yourName: "Your name",
  yourEmail: "Your e-mail",
  yourMessage: "Your message",
  buttonText: "Send Message",

  // **** Footer ****
  address: "Ujezd 11, 150 00 Prague",
  country: "Czech Republic",
  // **** Rights ****
  createdBy: "Created by",
  rightsReceived: "All rights reserved",
}

const cz = {
  // **** Navigation ****
  navLink1: "Dům",
  navLink2: "Náš Příběh",
  navLink3: "Chléb",
  navLink4: "Pečivo",
  navLink5: "Prodejna",
  navLink6: "Kontakt",
  // **** Landing page ****
  welcomeSubheader: "Vítejte",
  bakeryHeader: "Jsme více než pekárna",
  bakeryGridBreadContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  bakeryGridPastriesContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  bakeryGridShopContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  bakeryGridOurStoryContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  bakeryGridContactContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // **** our Story page ****

  // **** our Breads page ****
  breadHeader: "Náš Chléb",
  breadDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 1
  ourBreadHeader1: "Whole grain bred",
  ourBreadDesc1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 2
  ourBreadHeader2: "Sourdough bred",
  ourBreadDesc2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 3
  ourBreadHeader3: "Multi grain bread",
  ourBreadDesc3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 4
  ourBreadHeader4: "Wholerye bred",
  ourBreadDesc4: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 5
  ourBreadHeader5: "Island bred",
  ourBreadDesc5: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 6
  ourBreadHeader6: "Cerial bred",
  ourBreadDesc6: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 7
  ourBreadHeader7: "Spelt bred",
  ourBreadDesc7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 8
  ourBreadHeader8: "Bulgur bred",
  ourBreadDesc8: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 9
  ourBreadHeader9: "Extra dark bred",
  ourBreadDesc9: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",

  // **** our Pastries page ****
  pastriesHeader: "our Pastries",
  pastriesDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 1
  ourPastriesHeader1: "Oat deligh",
  ourPastriesDesc1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 2
  ourPastriesHeader2: "Cleinia",
  ourPastriesDesc2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 3
  ourPastriesHeader3: "Bluberry cookie",
  ourPastriesDesc3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 4
  ourPastriesHeader4: "Artic dream",
  ourPastriesDesc4: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 5
  ourPastriesHeader5: "Island muffin",
  ourPastriesDesc5: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 6
  ourPastriesHeader6: "Ice cubes",
  ourPastriesDesc6: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 7
  ourPastriesHeader7: "Kettleballs",
  ourPastriesDesc7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 8
  ourPastriesHeader8: "Grandma's secret",
  ourPastriesDesc8: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  // Grid Item 9
  ourPastriesHeader9: "Oat respberry cookie",
  ourPastriesDesc9: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",

  // **** Contact page ****
  contactHeader: "kontakt",
  contactDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  openingHoursHeader: "Otevírací doba",
  openingHoursWeekdays: "Pondělí - Pátek",
  openingHoursWeekends: "Sobota a Neděle",
  getInTouchHeader: "Kontaktujte Nás",
  getInTouchAddress: "Újezd 11, 150 00 Praha, Česká republika",
  // Contact form
  yourName: "Vaše jméno",
  yourEmail: "Váš e-mail",
  yourMessage: "Vaša zpráva",
  buttonText: "Poslat Zprávu",

  // **** Footer ****
  address: "Ujezd 11, 150 00 Praha",
  country: "Česká Republika",
  // **** Rights ****
  createdBy: "Vytvořil",
  rightsReceived: "Všechna práva vyhrazena",
}

export default localize({ en, cz })
